/* Found this smooth scroll answer from this answer on StackOverflow https://stackoverflow.com/a/35370490 */
/* eslint-disable */
/**
 * Smoothly scrolling anywhere in 60 FPS
 * @param {number} x
 * @param {number} y
 * @param {number} scrollDuration in milliseconds
 */
export default function smoothScrollTo(x, y, scrollDuration) {
  x = Math.abs(x || 0);
  y = Math.abs(y || 0);
  scrollDuration = scrollDuration || 1500;

  let currentScrollY = window.scrollY,
    currentScrollX = window.scrollX,
    dirY = y > currentScrollY ? 1 : -1,
    dirX = x > currentScrollX ? 1 : -1,
    tick = 16.6667, // 1000 / 60
    scrollStep = Math.PI / (scrollDuration / tick),
    cosParameterY = currentScrollY / 2,
    cosParameterX = currentScrollX / 2,
    scrollCount = 0,
    scrollMargin;

  function step() {
    scrollCount = scrollCount + 1;

    if (window.scrollX !== x) {
      scrollMargin = cosParameterX + dirX * cosParameterX * Math.cos(scrollCount * scrollStep);
      window.scrollTo(0, (currentScrollX - scrollMargin));
    }

    if (window.scrollY !== y) {
      scrollMargin = cosParameterY + dirY * cosParameterY * Math.cos(scrollCount * scrollStep);
      window.scrollTo(0, (currentScrollY - scrollMargin));
    }

    if (window.scrollX !== x || window.scrollY !== y) {
      requestAnimationFrame(step);
    }
  }

  step();
}
